module.exports = __webpack_public_path__ + "fonts/Baskerville.5e94ed9e.ttf";